import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import Section from "../../Atoms/Section";
import H1 from "../../Atoms/H1";
import * as api from "../../../api"
import TableAdminData from "../../Components/TableAdminData";
import { AwardsObjectToString, publicToString, semicolonSeparatedToCommadSeparated } from "../../Utils/Format";
import CSVExportButton from "../../Components/CSVExportButton";

const Companies = (props) => {

    const [allCompanies, setAllCompanies] = useState(null);
    const [allProfiles, setAllProfiles] = useState(null);
    const [tableData, setTableData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if(props.fullUserLoading) return;
        if(!props.fullUser?.user) navigate("/");
        if(props.fullUser?.user && props.fullUser.user.role !== "admin") navigate("/");
    }, [props.fullUserLoading, props.fullUser, navigate])

    useEffect(() => {
        //get active users
        api.GetAllUsers().then(res => {
            const _activeUsers = res.data;
            setAllProfiles(_activeUsers)
            const _companies = [];

            for(let i = 0; i < _activeUsers.length; i++) {
                const user = _activeUsers[i];
                //for each user, add the company if the ids don't match
                if(user.company && !_companies.find(company => company.company._id === user.company.company._id)){

                    const owner = _activeUsers.find(_user => _user.user._id === user.company.company.ownerUserId);

                    _companies.push({...user.company, ownerEmail : owner.user.email});
                }
            }
            setAllCompanies(_companies)
        }
        ).catch(function (error) {
            console.log(error);
        });
    },[]);

    useEffect(() => {
        if(!allCompanies) return;
        
        const _tableData = [];
        _tableData.push([
            "Nom",
            "Responable",
            "Email",
            "Lien vers la société",
            "Lien pour éditer la société",
            "Lien vers la société HubSpot",
            "Activité (catégorie VIA)",
            "Savoirs faire",
            "Secteur d'activité",
            "Année de création",
            "Clientèle",
            "Positionnement",
            "Adresse",
            "Code postal",
            "Ville",
            "Pays",
            "Site web",
            "Téléphone",
            "Identifiant Twitter",
            "Identifiant Instagram",
            "Lien linkedin",
            "Photo de couverture",
            "Crédit photo de couverture",
            "Logo",
            "Crédit logo",
            "Nombre de salariés",
            "Chiffre d'affaires",
            "Chiffre d'affaires public",
            "Email de l'agence RP",
            "À propos FR",
            "À propos EN",
            "Awards",
            "Collaborateurs",
            "Projets",
        ]);

        for(let i = 0; i < allCompanies.length; i++){
            _tableData.push([
                allCompanies[i].hsCompany?.properties?.name,
                // ownerIdToName(allCompanies[i].company.ownerUserId),
                {select : true, defaultValue: allCompanies[i].company.ownerUserId, values : companyToCollaborators(allCompanies[i]), onChange: (e) => setNewCompanyOwner(e, allCompanies[i].company._id), value : ownerIdToName(allCompanies[i].company.ownerUserId)},
                allCompanies[i].hsCompany?.properties?.work_email,
                {link : true, value : "https://connectedby.lefrenchdesign.org/company?id=" + allCompanies[i].company._id},
                {link : true, value : "https://connectedby.lefrenchdesign.org/mycompany?id=" + btoa(allCompanies[i].ownerEmail)},
                {link : true, value : "https://app.hubspot.com/contacts/4837156/record/0-2/" + allCompanies[i].company.hubspotID},
                semicolonSeparatedToCommadSeparated(allCompanies[i].hsCompany?.properties?.cat_gorie_via),
                semicolonSeparatedToCommadSeparated(allCompanies[i].hsCompany?.properties?.savoir_faire),
                semicolonSeparatedToCommadSeparated(allCompanies[i].hsCompany?.properties?.secteur),
                allCompanies[i].hsCompany?.properties?.date_de_creation_de_l_entreprise ? allCompanies[i].hsCompany?.properties?.date_de_creation_de_l_entreprise.split("-")[0] : "",
                semicolonSeparatedToCommadSeparated(allCompanies[i].hsCompany?.properties?.clientele),
                semicolonSeparatedToCommadSeparated(allCompanies[i].hsCompany?.properties?.positionnement),
                allCompanies[i].hsCompany?.properties?.address,
                allCompanies[i].hsCompany?.properties?.zip,
                allCompanies[i].hsCompany?.properties?.city,
                allCompanies[i].hsCompany?.properties?.country,
                allCompanies[i].hsCompany?.properties?.website,
                allCompanies[i].hsCompany?.properties?.phone,
                allCompanies[i].hsCompany?.properties?.twitterhandle,
                allCompanies[i].hsCompany?.properties?.compte_instagram,
                allCompanies[i].hsCompany?.properties?.linkedin_company_page,
                allCompanies[i].company.cover_picture && {link : true, value : process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + allCompanies[i].company.cover_picture},
                allCompanies[i].company.coverCredit,
                allCompanies[i].company.logo && {link : true, value : process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + allCompanies[i].company.logo},
                allCompanies[i].company.logoCredit,
                allCompanies[i].hsCompany?.properties?.numberofemployees,
                allCompanies[i].hsCompany?.properties?.annualrevenue,
                publicToString(allCompanies[i].hsCompany?.properties?.showchiffre_d_affaire_de_l_entreprise),
                allCompanies[i].hsCompany?.properties?.email_agence_rp,
                allCompanies[i].hsCompany?.properties?.description_courte_fr,
                allCompanies[i].hsCompany?.properties?.description_courte_en,
                AwardsObjectToString(allCompanies[i].hsCompany?.properties?.awards),
                companyToCollaboratorsString(allCompanies[i]),
                companyToProjectsString(allCompanies[i]),
            ]);
        }

        setTableData(_tableData);

    }, [allCompanies])

    function ownerIdToName(ownerId){
        if(!allProfiles) return "";

        const user = allProfiles.find(user => user.user._id === ownerId);
        if(!user) return "";
        return user.hsProfile?.properties?.firstname + " " + user.hsProfile?.properties?.lastname + " (" + user.user.email + ")";
    }

    function companyToCollaborators(company){
        if(!company) return [];

        const users = allProfiles.filter(user => user.user.companyHubspotID === company.company.hubspotID).map(user => {
            return {
                value : user.user._id,
                label : userToNameAndEmail(user)
            }
        });
        if(!users) return [];
        return users;
    }

    function companyToCollaboratorsString(company){
        if(!company) return "";

        const users = allProfiles.filter(user => user.user.companyHubspotID === company.company.hubspotID);
        if(!users) return "";

        let string = "";
        for(let i = 0; i < users.length; i++){
            string += userToNameAndEmail(users[i]);
            if(i < users.length - 1) string += ", ";
        }
        return string;
    }

    function userToNameAndEmail(user){
        return user.hsProfile?.properties?.firstname + " " + user.hsProfile?.properties?.lastname + " (" + user.user.email + ")";
    }

    function setNewCompanyOwner(e, companyId){
        const newOwnerId = e.target.value;
        // console.log(newOwnerId, companyId)
        api.SetNewCompanyOwner({newOwnerId, companyId});
        alert("Données enregistrées");
    }

    function companyToProjectsString(company){
        if(!company) return "";

        const projects = company.company.projects;
        if(!projects) return "";

        let string = "";
        for(let i = 0; i < projects.length; i++){
            string += projects[i].name;
            if(i < projects.length - 1) string += ", ";
        }

        return string;
    }

    if (props.fullUserLoading || !allCompanies || !tableData){
        return (<>
            <br/><br/><br/>
            <Spinner/>
        </>)
    }

    return (<>
        <Section className="padding flexblock" style={{justifyContent:"space-between"}}>
            <H1>Sociétés ({allCompanies.length})</H1>
            <CSVExportButton data={tableData} filename="sociétés.csv"/>
        </Section>
        <Section>
            <TableAdminData data={tableData}/>
        </Section>
    </>)
}

export default Companies;